import React, { useState, useEffect } from 'react';
import moment from 'moment';
import axios from 'axios';

import { getBulletinMessage, momentTz } from '../../../utils/Helpers';
import { BULLETIN } from '../../../constants';

import { getActiveBulletin } from './Bulletin.service';

const BulletinMarquee = () => {
  const [bulletinList, setBulletinList] = useState([]);

  useEffect(async () => {
    if (axios.defaults.headers.common['client-id']) {
      const bulletinList = await getActiveBulletin(
        BULLETIN.TOPBAR,
        momentTz(moment()).utc().format('YYYY-MM-DD HH:mm:ss')
      );

      setBulletinList(bulletinList);
    }
  }, [axios.defaults.headers.common['client-id']]);

  useEffect(() => {
    window.marqueeText = false;
    if (bulletinList?.length > 0) {
      window.marqueeText = true;
    }
  }, [bulletinList?.length]);
  return (
    <>
      {bulletinList?.length ? (
        <div className="w-full h-2rem main-body pr-3 md:pr-0">
          <marquee className="w-full md:fixed bg-white h-2rem flex align-items-center md:z-5">
            {bulletinList?.map((bulletin, index) => (
              <span className="mr-4" key={index}>
                <i className="pi pi-megaphone w-1rem text-xs text-primary"></i>
                <span className="text-color">
                  {getBulletinMessage(bulletin)}
                </span>
              </span>
            ))}
          </marquee>
        </div>
      ) : null}
    </>
  );
};

export default BulletinMarquee;
